// @flow
import useQuery, { useUpdateURLSearchParams } from "hooks/useQuery";
import React, { type Node, useCallback, useRef, useState } from "react";
import cn from "utils/tailwind/cn";

import Icons from "./Icons";

type Props = {
  value?: string,
  onChange?: (string) => void,
  placeholder?: string,
  className?: string,
};

export function SearchBar({
  value,
  onChange,
  placeholder,
  className,
}: Props): Node {
  const query = useQuery();
  const updateParams = useUpdateURLSearchParams();
  const onChangeSearch = (search: string) =>
    updateParams(["search", search], ["page", "1"]);

  const inputRef = useRef(null);
  const [hasFocus, setFocus] = useState(false);

  const focusInput = useCallback(
    () => !hasFocus && inputRef?.current?.focus(),
    [hasFocus],
  );
  const onFocus = () => setFocus(true);
  const onBlur = () => setFocus(false);

  return (
    <div
      className={cn(
        "flex items-center form-input border cursor-text w-full rounded",
        className,
      )}
      onClick={focusInput}
    >
      <div className="pr-2">
        <Icons.Search color="text-gray-400" size="4" />
      </div>
      <input
        className="flex-1 transition ease-in-out duration-150 text-sm md:text-base sm:leading-5 focus:outline-none"
        onBlur={onBlur}
        onChange={(e) => {
          if (onChange) {
            onChange(e?.target?.value);
          } else {
            onChangeSearch(e?.target?.value);
          }
        }}
        onFocus={onFocus}
        placeholder={placeholder || "Search"}
        ref={inputRef}
        type="text"
        value={value || query.get("search") || ""}
      />
    </div>
  );
}

export default SearchBar;
